module.exports = __webpack_public_path__ + "img/google_logo.88ae536c.svg";